import React from 'react';

function About() {
  return (
    <section id="about">
      <h2>About Crawford Family Bank</h2>
      <p>
        Direct lending and debt financing solutions 'tailor-made' to the specific requirements of the businesses, families and private equity sponsors with whom we work with. 
      </p>
    </section>
  );
}

export default About;